module.exports = __webpack_public_path__ + "static/media/testImage7.469f1c40.png";